import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TickerContextProvider } from "./context";

export const TickerProvider = ({ children }) => {
  const [now, setNow] = useState(Math.round(Date.now() / 1000));

  useEffect(() => {
    let requestId;
    let lastTimestamp;

    const tick = (timestamp) => {
      if (!lastTimestamp) {
        lastTimestamp = timestamp;
      }
      const elapsed = timestamp - lastTimestamp;

      if (elapsed >= 60000) {
        setNow(Math.round(Date.now() / 1000));
        lastTimestamp = timestamp;
      }

      requestId = requestAnimationFrame(tick);
    };

    requestId = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(requestId);
    };
  }, []);

  return (
    <TickerContextProvider
      value={{
        now,
      }}
    >
      {children}
    </TickerContextProvider>
  );
};

TickerProvider.propTypes = {
  children: PropTypes.any,
};
